import React, { useEffect } from "react";


const StatsBlock = ({ className = "" }) => {


  return (
    <>
      <div className={`stats-block ${className}`}>
        <p>
          <label>Total Uploaded</label>
          <span>210</span>
        </p>
        <p>
          <label>Total Validated</label>
          <span>133</span>
        </p>
      </div>
    </>
  );
};
export default StatsBlock;